import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import {
    Aangifte,
    AangifteBerekening,
    AangifteRapport, BokkzAlgDataService,
    BokkzIbDataService, Box1Berekening,
    IncomeTaxEntity, OpbouwInkomenBox1, OpbouwPU, OpbouwROW, SpecificatiePU, SpecificatieROW
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject, combineLatest, filter, Subscription } from 'rxjs';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';
import { SharedUiAlertModule } from '@snelstart/ui-alert';

@Component({
    selector:
        'snelstart-venture-fiscaal-feature-box1-resultaat-overige-werkzaamheden',
    templateUrl: './box1-resultaat-overige-werkzaamheden.component.html',
    styleUrls: ['./box1-resultaat-overige-werkzaamheden.component.scss'],
    imports: [
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        CommonModule,
        SharedUiAlertModule
    ]
})

export class Box1ResultaatOverigeWerkzaamhedenComponent implements OnInit, OnDestroy {

    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private dataSubscription: Subscription | undefined;

    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);

    public partnerBoolean = false;
    berekening = {} as AangifteBerekening;

    public isDefAangifte = {} as boolean;

    specRapportFormGroup = this.fb.group<AangifteRapport>({});

    rapport = {} as AangifteRapport;
    berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder) {
        this.specRapportFormGroup = this.fb.group<AangifteRapport>(({
            specificatieROW: this.fb.group<SpecificatieROW>(({
                opbouw: this.fb.group<OpbouwROW>(({
                    berekendResultaatUitOverigeWerkzaamheden: null as unknown as number,
                    inkomstenUitOVerigeWerkzaamheden: null as unknown as number,
                    kostenTerZakeVanOverigeWerkzaamheden: null as unknown as number,
                    inkomstenUitTBS: null as unknown as number,
                    kostenTerZakeVanTBS: null as unknown as number,
                    tbsVrijstelling: null as unknown as number,
                    saldoRow: null as unknown as number,
                    saldoTbs: null as unknown as number
                } as OpbouwROW))
            } as SpecificatieROW)),
            specificatiePU: this.fb.group<SpecificatiePU>(({
                opbouw: this.fb.group<OpbouwPU>(({
                    berekendeUitkomst: null as unknown as number,
                    ontvangenAlimentatie: null as unknown as number,
                    kostenAlimentatie: null as unknown as number,
                    ontvangenPeriodiekeUitkeringen: null as unknown as number,
                    kostenPeriodiekeUitkeringen: null as unknown as number,
                    saldoAlimentatie: null as unknown as number,
                    saldoPerUitkeringen: null as unknown as number
                } as OpbouwPU))
            } as SpecificatiePU))

        } as AangifteRapport));
        this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                opbouwInkomen: this.fb.group<OpbouwInkomenBox1>(({
                    resultaatUitOverigeWerkzaamheden: null as unknown as number,
                    periodiekeUitkeringen: null as unknown as number
                } as OpbouwInkomenBox1))
            } as Box1Berekening))
        } as AangifteBerekening));
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.dataSubscription = combineLatest([
            this.dataService.incomeTaxEntity,
            this.dataService.aangifteBerekening,
            this.dataService.partnerAangifteBerekening,
            this.dataService.partnerAangifteRapport,
            this.dataService.aangifteRapport,
            this.partner]).subscribe(
            ([incomeTaxEntity, aangeverBerekening, partnerBerekening,
                 partnerRapport, aangifteRapport, partner]) => {
                this.berekeningBox1FormGroup.reset();
                this.specRapportFormGroup.reset();
                this.partnerBoolean = partner;
                if (this.partnerBoolean) {
                    this.rapport = partnerRapport;
                    this.berekening = partnerBerekening;
                    if (this.berekening) {
                        this.berekeningBox1FormGroup.patchValue(this.berekening);
                        this.specRapportFormGroup.patchValue(this.rapport);
                        this.updateSaldoAlimentatie();
                        this.updateSaldoPerUitkeringen();
                        this.updateSaldoRow();
                        this.updateSaldoTbs();
                        if (incomeTaxEntity.aangifte) {
                            const aangifte = incomeTaxEntity.aangifte as Aangifte;
                            this.aangifte = aangifte;
                        }
                    }
                } else {
                    this.rapport = aangifteRapport;
                    this.berekening = aangeverBerekening;
                    if (this.berekening) {
                        this.berekeningBox1FormGroup.patchValue(this.berekening);
                        this.specRapportFormGroup.patchValue(this.rapport);
                        this.updateSaldoAlimentatie();
                        this.updateSaldoPerUitkeringen();
                        this.updateSaldoRow();
                        this.updateSaldoTbs();
                        if (incomeTaxEntity.aangifte) {
                            const aangifte = incomeTaxEntity.aangifte as Aangifte;
                            this.aangifte = aangifte;
                        }
                    }
                }
                this.disableFormGroup(this.specRapportFormGroup);
                this.disableFormGroup(this.berekeningBox1FormGroup);
            }
        );

    }

    ngOnDestroy(): void {
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
    }


    private updateSaldoRow() {
        const inkomsten = this.rapport.specificatieROW?.opbouw?.inkomstenUitOVerigeWerkzaamheden || 0;
        const kosten = this.rapport.specificatieROW?.opbouw?.kostenTerZakeVanOverigeWerkzaamheden || 0;

        const saldo = inkomsten - kosten;
        this.specRapportFormGroup.get('specificatieROW.opbouw.saldoRow')?.setValue(saldo);
    }

    private updateSaldoTbs() {
        const inkomsten = this.rapport.specificatieROW?.opbouw?.inkomstenUitTBS || 0;
        const kosten = this.rapport.specificatieROW?.opbouw?.kostenTerZakeVanTBS || 0;
        const vrijstelling = this.rapport.specificatieROW?.opbouw?.tbsVrijstelling || 0;

        const saldo = inkomsten - kosten - vrijstelling;
        this.specRapportFormGroup.get('specificatieROW.opbouw.saldoTbs')?.setValue(saldo);
    }


    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    public heeftOverigeInkomsten(): boolean {
        if (this.partnerBoolean) {
            return !!(this.aangifte && this.aangifte.partnerAangifte && this.aangifte.partnerAangifte.box1 &&
                (this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden &&
                    (this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden.rowOpbrengsten &&
                        this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden.rowOpbrengsten.length > 0) ||
                    (this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden?.rowKosten &&
                        this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden.rowKosten.length > 0) ||
                    (this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden?.tbsOpbrengsten &&
                        this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden.tbsOpbrengsten.length > 0) ||
                    (this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden?.tbsKosten &&
                        this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden.tbsKosten.length > 0)) ||
                ((this.aangifte?.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen &&
                    (this.aangifte?.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen.inkomstenPeriodiekeUitkeringen &&
                        this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.inkomstenPeriodiekeUitkeringen.length > 0) ||
                    (this.aangifte?.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenPeriodiekeUitkeringen &&
                        this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.aftrekbareKostenPeriodiekeUitkeringen.length > 0) ||
                    (this.aangifte?.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.ontvangenAlimentatie &&
                        this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.ontvangenAlimentatie.length > 0) ||
                    (this.aangifte?.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenAlimentatie &&
                        this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.aftrekbareKostenAlimentatie.length > 0))));
        } else {
            return !!(this.aangifte && this.aangifte.box1 &&
                (this.aangifte.box1.resultaatUitOverigeWerkzaamheden &&
                    (this.aangifte.box1.resultaatUitOverigeWerkzaamheden.rowOpbrengsten &&
                        this.aangifte.box1.resultaatUitOverigeWerkzaamheden.rowOpbrengsten.length > 0) ||
                    (this.aangifte.box1.resultaatUitOverigeWerkzaamheden?.rowKosten &&
                        this.aangifte.box1.resultaatUitOverigeWerkzaamheden.rowKosten.length > 0) ||
                    (this.aangifte.box1.resultaatUitOverigeWerkzaamheden?.tbsOpbrengsten &&
                        this.aangifte.box1.resultaatUitOverigeWerkzaamheden.tbsOpbrengsten.length > 0) ||
                    (this.aangifte.box1.resultaatUitOverigeWerkzaamheden?.tbsKosten &&
                        this.aangifte.box1.resultaatUitOverigeWerkzaamheden.tbsKosten.length > 0)) ||
                ((this.aangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen &&
                    (this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.inkomstenPeriodiekeUitkeringen &&
                        this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.inkomstenPeriodiekeUitkeringen.length > 0) ||
                    (this.aangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenPeriodiekeUitkeringen &&
                        this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.aftrekbareKostenPeriodiekeUitkeringen.length > 0) ||
                    (this.aangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.ontvangenAlimentatie &&
                        this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.ontvangenAlimentatie.length > 0) ||
                    (this.aangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenAlimentatie &&
                        this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.aftrekbareKostenAlimentatie.length > 0))));
        }
    }

    public heeftRow(): boolean {
        if (this.partnerBoolean) {
            return !!(this.aangifte && this.aangifte.partnerAangifte && this.aangifte.partnerAangifte.box1 &&
                (this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden &&
                    (this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden.rowOpbrengsten &&
                        this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden.rowOpbrengsten.length > 0) ||
                    (this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden?.rowKosten &&
                        this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden.rowKosten.length > 0)));
        } else {
            return !!(this.aangifte && this.aangifte.box1 &&
                (this.aangifte.box1.resultaatUitOverigeWerkzaamheden &&
                    (this.aangifte.box1.resultaatUitOverigeWerkzaamheden.rowOpbrengsten &&
                        this.aangifte.box1.resultaatUitOverigeWerkzaamheden.rowOpbrengsten.length > 0) ||
                    (this.aangifte.box1.resultaatUitOverigeWerkzaamheden?.rowKosten &&
                        this.aangifte.box1.resultaatUitOverigeWerkzaamheden.rowKosten.length > 0)));
        }
    }

    public heeftTbs(): boolean {
        if (this.partnerBoolean) {
            return !!(this.aangifte && this.aangifte.partnerAangifte && this.aangifte.partnerAangifte.box1 &&
                ((this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden?.tbsOpbrengsten &&
                        this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden.tbsOpbrengsten.length > 0) ||
                    (this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden?.tbsKosten &&
                        this.aangifte.partnerAangifte.box1.resultaatUitOverigeWerkzaamheden.tbsKosten.length > 0)));
        } else {
            return !!(this.aangifte && this.aangifte.box1 &&
                (this.aangifte.box1.resultaatUitOverigeWerkzaamheden &&
                    (this.aangifte.box1.resultaatUitOverigeWerkzaamheden?.tbsOpbrengsten &&
                        this.aangifte.box1.resultaatUitOverigeWerkzaamheden.tbsOpbrengsten.length > 0) ||
                    (this.aangifte.box1.resultaatUitOverigeWerkzaamheden?.tbsKosten &&
                        this.aangifte.box1.resultaatUitOverigeWerkzaamheden.tbsKosten.length > 0)));
        }
    }

    public heeftAlimentatie(): boolean {
        if (this.partnerBoolean) {
            return !!(this.aangifte && this.aangifte.partnerAangifte && this.aangifte.partnerAangifte.box1 &&
                (this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen &&
                    (this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.ontvangenAlimentatie &&
                        this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.ontvangenAlimentatie.length > 0) ||
                    (this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenAlimentatie &&
                        this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.aftrekbareKostenAlimentatie.length > 0)));
        } else {
            return !!(this.aangifte && this.aangifte.box1 &&
                (this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen &&
                    (this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.ontvangenAlimentatie &&
                        this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.ontvangenAlimentatie.length > 0) ||
                    (this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenAlimentatie &&
                        this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.aftrekbareKostenAlimentatie.length > 0)));
        }
    }

    public heeftPerUitkeringen(): boolean {
        if (this.partnerBoolean) {
            return !!(this.aangifte && this.aangifte.partnerAangifte && this.aangifte.partnerAangifte.box1 &&
                ((this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.inkomstenPeriodiekeUitkeringen &&
                        this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.inkomstenPeriodiekeUitkeringen.length > 0) ||
                    (this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenPeriodiekeUitkeringen &&
                        this.aangifte.partnerAangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.aftrekbareKostenPeriodiekeUitkeringen.length > 0)));
        } else {
            return !!(this.aangifte && this.aangifte.box1 &&
                (this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen &&
                    (this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.inkomstenPeriodiekeUitkeringen &&
                        this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.inkomstenPeriodiekeUitkeringen.length > 0) ||
                    (this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenPeriodiekeUitkeringen &&
                        this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen.aftrekbareKostenPeriodiekeUitkeringen.length > 0)));
        }
    }

    private updateSaldoAlimentatie() {
        const inkomsten = this.rapport.specificatiePU?.opbouw?.ontvangenAlimentatie || 0;
        const kosten = this.rapport.specificatiePU?.opbouw?.kostenAlimentatie || 0;

        const saldo = inkomsten - kosten;
        this.specRapportFormGroup.get('specificatiePU.opbouw.saldoAlimentatie')?.setValue(saldo);
    }

    private updateSaldoPerUitkeringen() {
        const inkomsten = this.rapport.specificatiePU?.opbouw?.ontvangenPeriodiekeUitkeringen || 0;
        const kosten = this.rapport.specificatiePU?.opbouw?.kostenPeriodiekeUitkeringen || 0;

        const saldo = inkomsten - kosten;
        this.specRapportFormGroup.get('specificatiePU.opbouw.saldoPerUitkeringen')?.setValue(saldo);
    }
}
